<template>
  <div class="pages hsjpro_opensource">
    <div class="hsjpro_opensource_container">
      <p>
        The following 3rd-party software packages may be used by or distributed
        with this product. Any information relevant to third-party vendors
        listed below are collected using common, reasonable means.
      </p>
      <h1><a id="_2"></a></h1>
      <p>Activity : Apache License 2.0</p>
      <p>Android Support VectorDrawable : Apache License 2.0</p>
      <p>Android Support legacy : Apache License 2.0</p>
      <p>Android AppCompat Library : Apache License 2.0</p>
      <p>Android Resources Library : Apache License 2.0</p>
      <p>Android Support CardView v7 : Apache License 2.0</p>
      <p>Android ConstraintLayout : Apache License 2.0</p>
      <p>Android Support Library Coordinator Layout : Apache License 2.0</p>
      <p>Android Support Library core utils : Apache License 2.0</p>
      <p>Android Library : Apache License 2.0</p>
      <p>Android Lifecycle Viewmodel : Apache License 2.0</p>
      <p>Android Lifecycle Viewmodel Savedstate : Apache License 2.0</p>
      <p>Android Lifecycle Runtime : Apache License 2.0</p>
      <p>Android Lifecycle LiveData : Apache License 2.0</p>
      <p>Android Lifecycle LiveData Core : Apache License 2.0</p>
      <p>Android Support Library core UI : Apache License 2.0</p>
      <p>Android Support Library Cursor Adapter : Apache License 2.0</p>
      <p>
        Android Support Library Custom View - androidx.customview:customview :
        Apache License 2.0
      </p>
      <p>Android Material Design : Apache License 2.0</p>
      <p>Android Support Library Document File : Apache License 2.0</p>
      <p>Android Support Library Drawer Layout : Apache License 2.0</p>
      <p>Android Exifinterface : Apache License 2.0</p>
      <p>Android Support Library fragment : Apache License 2.0</p>
      <p>Android Support Library Interpolators : Apache License 2.0</p>
      <p>Android Support legacy core ui : Apache License 2.0</p>
      <p>Android Support legacy core utils : Apache License 2.0</p>
      <p>Android Support Library loader : Apache License 2.0</p>
      <p>
        Android Support Library Local Broadcast Manager : Apache License 2.0
      </p>
      <p>Android Support Library media compat : Apache License 2.0</p>
      <p>Android Multidex : Apache License 2.0</p>
      <p>Android Navigation Common : Apache License 2.0</p>
      <p>Android Navigation Fragment : Apache License 2.0</p>
      <p>Android Navigation Runtime : Apache License 2.0</p>
      <p>Android Navigation UI : Apache License 2.0</p>
      <p>Android Support Palette v7 : Apache License 2.0</p>
      <p>Android Support Library Print : Apache License 2.0</p>
      <p>androidx.savedstate:savedstate : Apache License 2.0</p>
      <p>Android Slidingpanelayoute : Apache License 2.0</p>
      <p>Android Tracing : Apache License 2.0</p>
      <p>
        Android Support Library Custom View -
        androidx.swiperefreshlayout:swiperefreshlayout : Apache License 2.0
      </p>
      <p>Android Transition Support Library : Apache License 2.0</p>
      <p>Android Support AnimatedVectorDrawable : Apache License 2.0</p>
      <p>Android Versionedparcelable : Apache License 2.0</p>
      <p>Android Viewbinding : Apache License 2.0</p>
      <p>AndroidX Widget ViewPager : Apache License 2.0</p>
      <p>AndroidX Widget ViewPager2 : Apache License 2.0</p>
      <p>AndroidX Asynclayoutinflater : Apache License 2.0</p>
      <p>Android Databinding Library BaseAdapters: Apache License 2.0</p>
      <p>Banner: Apache License 2.0</p>
      <p>Experimental annotation : Apache License 2.0</p>
      <p>Jackson : Apache License 2.0</p>
      <p>Jackson databind : Apache License 2.0</p>
      <p>java-annotations: Apache License 2.0</p>
      <p>
        Material Components for Android - com.google.android.material:material :
        Apache License 2.0
      </p>
      <p>OpenSSL: Apache License 2.0</p>
      <p>Recyclerview: Apache License 2.0</p>
      <p>RxTools: Apache License 2.0</p>
      <p>
        ================================================================================<br />
        Licenses<br />
        ================================================================================
      </p>
      <p>
        Apache License<br />
        Version 2.0, January 2004<br />
        <a href="http://www.apache.org/licenses/" target="_blank"
          >http://www.apache.org/licenses/</a
        >
      </p>
      <p>TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION</p>
      <p>1.Definitions.</p>
      <p>
        “License” shall mean the terms and conditions for use, reproduction,<br />
        and distribution as defined by Sections 1 through 9 of this document.
      </p>
      <p>
        “Licensor” shall mean the copyright owner or entity authorized by<br />
        the copyright owner that is granting the License.
      </p>
      <p>
        “Legal Entity” shall mean the union of the acting entity and all<br />
        other entities that control, are controlled by, or are under common<br />
        control with that entity. For the purposes of this definition,<br />
        “control” means (i) the power, direct or indirect, to cause the<br />
        direction or management of such entity, whether by contract or<br />
        otherwise, or (ii) ownership of fifty percent (50%) or more of the<br />
        outstanding shares, or (iii) beneficial ownership of such entity.
      </p>
      <p>
        “You” (or “Your”) shall mean an individual or Legal Entity<br />
        exercising permissions granted by this License.
      </p>
      <p>
        “Source” form shall mean the preferred form for making modifications,<br />
        including but not limited to software source code, documentation<br />
        source, and configuration files.
      </p>
      <p>
        “Object” form shall mean any form resulting from mechanical<br />
        transformation or translation of a Source form, including but<br />
        not limited to compiled object code, generated documentation,<br />
        and conversions to other media types.
      </p>
      <p>
        “Work” shall mean the work of authorship, whether in Source or<br />
        Object form, made available under the License, as indicated by a<br />
        copyright notice that is included in or attached to the work<br />
        (an example is provided in the Appendix below).
      </p>
      <p>
        “Derivative Works” shall mean any work, whether in Source or Object<br />
        form, that is based on (or derived from) the Work and for which the<br />
        editorial revisions, annotations, elaborations, or other
        modifications<br />
        represent, as a whole, an original work of authorship. For the
        purposes<br />
        of this License, Derivative Works shall not include works that remain<br />
        separable from, or merely link (or bind by name) to the interfaces
        of,<br />
        the Work and Derivative Works thereof.
      </p>
      <p>
        “Contribution” shall mean any work of authorship, including<br />
        the original version of the Work and any modifications or additions<br />
        to that Work or Derivative Works thereof, that is intentionally<br />
        submitted to Licensor for inclusion in the Work by the copyright
        owner<br />
        or by an individual or Legal Entity authorized to submit on behalf of<br />
        the copyright owner. For the purposes of this definition, “submitted”<br />
        means any form of electronic, verbal, or written communication sent<br />
        to the Licensor or its representatives, including but not limited to<br />
        communication on electronic mailing lists, source code control
        systems,<br />
        and issue tracking systems that are managed by, or on behalf of, the<br />
        Licensor for the purpose of discussing and improving the Work, but<br />
        excluding communication that is conspicuously marked or otherwise<br />
        designated in writing by the copyright owner as “Not a Contribution.”
      </p>
      <p>
        “Contributor” shall mean Licensor and any individual or Legal Entity<br />
        on behalf of whom a Contribution has been received by Licensor and<br />
        subsequently incorporated within the Work.
      </p>
      <p>
        Grant of Copyright License. Subject to the terms and conditions of<br />
        this License, each Contributor hereby grants to You a perpetual,<br />
        worldwide, non-exclusive, no-charge, royalty-free, irrevocable<br />
        copyright license to reproduce, prepare Derivative Works of,<br />
        publicly display, publicly perform, sublicense, and distribute the<br />
        Work and such Derivative Works in Source or Object form.
      </p>
      <p>
        2.Grant of Patent License. Subject to the terms and conditions of this
        License, each Contributor hereby grants to You a perpetual, worldwide,
        non-exclusive, no-charge, royalty-free, irrevocable (except as stated in
        this section) patent license to make, have made, use, offer to sell,
        sell, import, and otherwise transfer the Work, where such license
        applies only to those patent claims licensable by such Contributor that
        are necessarily infringed by their Contribution(s) alone or by
        combination of their Contribution(s) with the Work to which such
        Contribution(s) was submitted. If You institute patent litigation
        against any entity (including a cross-claim or counterclaim in a
        lawsuit) alleging that the Work or a Contribution incorporated within
        the Work constitutes direct or contributory patent infringement, then
        any patent licenses granted to You under this License for that Work
        shall terminate as of the date such litigation is filed.
      </p>
      <p>
        Redistribution. You may reproduce and distribute copies of the<br />
        Work or Derivative Works thereof in any medium, with or without<br />
        modifications, and in Source or Object form, provided that You<br />
        meet the following conditions:
      </p>
      <p>
        (a) You must give any other recipients of the Work or<br />
        Derivative Works a copy of this License; and
      </p>
      <ol>
        <li>
          <p>
            (b) You must cause any modified files to carry prominent notices<br />
            stating that You changed the files; and
          </p>
          <p>
            © You must retain, in the Source form of any Derivative Works<br />
            that You distribute, all copyright, patent, trademark, and<br />
            attribution notices from the Source form of the Work,<br />
            excluding those notices that do not pertain to any part of<br />
            the Derivative Works; and
          </p>
          <p>
            (d) If the Work includes a “NOTICE” text file as part of its<br />
            distribution, then any Derivative Works that You distribute must<br />
            include a readable copy of the attribution notices contained<br />
            within such NOTICE file, excluding those notices that do not<br />
            pertain to any part of the Derivative Works, in at least one<br />
            of the following places: within a NOTICE text file distributed<br />
            as part of the Derivative Works; within the Source form or<br />
            documentation, if provided along with the Derivative Works; or,<br />
            within a display generated by the Derivative Works, if and<br />
            wherever such third-party notices normally appear. The contents<br />
            of the NOTICE file are for informational purposes only and<br />
            do not modify the License. You may add Your own attribution<br />
            notices within Derivative Works that You distribute, alongside<br />
            or as an addendum to the NOTICE text from the Work, provided<br />
            that such additional attribution notices cannot be construed<br />
            as modifying the License.
          </p>
          <p>
            You may add Your own copyright statement to Your modifications
            and<br />
            may provide additional or different license terms and conditions<br />
            for use, reproduction, or distribution of Your modifications, or<br />
            for any such Derivative Works as a whole, provided Your use,<br />
            reproduction, and distribution of the Work otherwise complies
            with<br />
            the conditions stated in this License.
          </p>
        </li>
        <li>
          <p>
            Submission of Contributions. Unless You explicitly state
            otherwise,<br />
            any Contribution intentionally submitted for inclusion in the
            Work<br />
            by You to the Licensor shall be under the terms and conditions of<br />
            this License, without any additional terms or conditions.<br />
            Notwithstanding the above, nothing herein shall supersede or
            modify<br />
            the terms of any separate license agreement you may have executed<br />
            with Licensor regarding such Contributions.
          </p>
        </li>
        <li>
          <p>
            Trademarks. This License does not grant permission to use the
            trade<br />
            names, trademarks, service marks, or product names of the
            Licensor,<br />
            except as required for reasonable and customary use in describing
            the<br />
            origin of the Work and reproducing the content of the NOTICE file.
          </p>
        </li>
        <li>
          <p>
            Disclaimer of Warranty. Unless required by applicable law or<br />
            agreed to in writing, Licensor provides the Work (and each<br />
            Contributor provides its Contributions) on an “AS IS” BASIS,<br />
            WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or<br />
            implied, including, without limitation, any warranties or
            conditions<br />
            of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A<br />
            PARTICULAR PURPOSE. You are solely responsible for determining
            the<br />
            appropriateness of using or redistributing the Work and assume
            any<br />
            risks associated with Your exercise of permissions under this
            License.
          </p>
        </li>
        <li>
          <p>
            Limitation of Liability. In no event and under no legal theory,<br />
            whether in tort (including negligence), contract, or otherwise,<br />
            unless required by applicable law (such as deliberate and grossly<br />
            negligent acts) or agreed to in writing, shall any Contributor be<br />
            liable to You for damages, including any direct, indirect,
            special,<br />
            incidental, or consequential damages of any character arising as
            a<br />
            result of this License or out of the use or inability to use the<br />
            Work (including but not limited to damages for loss of goodwill,<br />
            work stoppage, computer failure or malfunction, or any and all<br />
            other commercial damages or losses), even if such Contributor<br />
            has been advised of the possibility of such damages.
          </p>
        </li>
        <li>
          <p>
            Accepting Warranty or Additional Liability. While redistributing<br />
            the Work or Derivative Works thereof, You may choose to offer,<br />
            and charge a fee for, acceptance of support, warranty, indemnity,<br />
            or other liability obligations and/or rights consistent with this<br />
            License. However, in accepting such obligations, You may act only<br />
            on Your own behalf and on Your sole responsibility, not on behalf<br />
            of any other Contributor, and only if You agree to indemnify,<br />
            defend, and hold each Contributor harmless for any liability<br />
            incurred by, or claims asserted against, such Contributor by
            reason<br />
            of your accepting any such warranty or additional liability.
          </p>
        </li>
      </ol>
      <p>END OF TERMS AND CONDITIONS</p>
      <p>APPENDIX: How to apply the Apache License to your work.</p>
      <p>
        To apply the Apache License to your work, attach the following<br />
        boilerplate notice, with the fields enclosed by brackets “{}”<br />
        replaced with your own identifying information. (Don’t include<br />
        the brackets!) The text should be enclosed in the appropriate<br />
        comment syntax for the file format. We also recommend that a<br />
        file or class name and description of purpose be included on the<br />
        same “printed page” as the copyright notice for easier<br />
        identification within third-party archives.
      </p>
      <p>Copyright {yyyy} {name of copyright owner}</p>
      <p>
        Licensed under the Apache License, Version 2.0 (the “License”);<br />
        you may not use this file except in compliance with the License.<br />
        You may obtain a copy of the License at
      </p>
      <p>
        <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank"
          >http://www.apache.org/licenses/LICENSE-2.0</a
        >
      </p>
      <p>
        Unless required by applicable law or agreed to in writing, software<br />
        distributed under the License is distributed on an “AS IS” BASIS,<br />
        WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
        implied.<br />
        See the License for the specific language governing permissions and<br />
        limitations under the License.
      </p>
      <h1><a id="protobufjava_310"></a>protobuf-java</h1>
      <p>Copyright 2008 Google Inc.</p>
      <p>
        Licensed under the Apache License, Version 2.0 (the “License”);<br />
        you may not use this file except in compliance with the License.<br />
        You may obtain a copy of the License at
      </p>
      <p>
        <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank"
          >http://www.apache.org/licenses/LICENSE-2.0</a
        >
      </p>
      <p>
        Unless required by applicable law or agreed to in writing, software<br />
        distributed under the License is distributed on an “AS IS” BASIS,<br />
        WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
        implied.<br />
        See the License for the specific language governing permissions and<br />
        limitations under the License.
      </p>
      <h1><a id="OkHttp_326"></a>OkHttp</h1>
      <p>Copyright 2019 Square, Inc.</p>
      <p>
        Licensed under the Apache License, Version 2.0 (the “License”);<br />
        you may not use this file except in compliance with the License.<br />
        You may obtain a copy of the License at
      </p>
      <p>
        <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank"
          >http://www.apache.org/licenses/LICENSE-2.0</a
        >
      </p>
      <p>
        Unless required by applicable law or agreed to in writing, software<br />
        distributed under the License is distributed on an “AS IS” BASIS,<br />
        WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
        implied.<br />
        See the License for the specific language governing permissions and<br />
        limitations under the License.
      </p>
      <h1><a id="retrofit_342"></a>retrofit</h1>
      <p>Copyright 2013 Square, Inc.</p>
      <p>
        Licensed under the Apache License, Version 2.0 (the “License”);<br />
        you may not use this file except in compliance with the License.<br />
        You may obtain a copy of the License at
      </p>
      <p>
        <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank"
          >http://www.apache.org/licenses/LICENSE-2.0</a
        >
      </p>
      <p>
        Unless required by applicable law or agreed to in writing, software<br />
        distributed under the License is distributed on an “AS IS” BASIS,<br />
        WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
        implied.<br />
        See the License for the specific language governing permissions and<br />
        limitations under the License.
      </p>
      <h1><a id="RxAndroid_358"></a>RxAndroid</h1>
      <p>Copyright 2015 The RxAndroid authors</p>
      <p>
        Licensed under the Apache License, Version 2.0 (the “License”);<br />
        you may not use this file except in compliance with the License.<br />
        You may obtain a copy of the License at
      </p>
      <p>
        <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank"
          >http://www.apache.org/licenses/LICENSE-2.0</a
        >
      </p>
      <p>
        Unless required by applicable law or agreed to in writing, software<br />
        distributed under the License is distributed on an “AS IS” BASIS,<br />
        WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
        implied.<br />
        See the License for the specific language governing permissions and<br />
        limitations under the License.
      </p>
      <h1><a id="RxJava_374"></a>RxJava</h1>
      <p>Copyright © 2016-present, RxJava Contributors.</p>
      <p>
        Licensed under the Apache License, Version 2.0 (the “License”);<br />
        you may not use this file except in compliance with the License.<br />
        You may obtain a copy of the License at
      </p>
      <p>
        <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank"
          >http://www.apache.org/licenses/LICENSE-2.0</a
        >
      </p>
      <p>
        Unless required by applicable law or agreed to in writing, software<br />
        distributed under the License is distributed on an “AS IS” BASIS,<br />
        WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
        implied.<br />
        See the License for the specific language governing permissions and<br />
        limitations under the License.
      </p>
      <h1><a id="glide_390"></a>glide</h1>
      <p>License for everything not in third_party and not otherwise marked:</p>
      <p>Copyright 2014 Google, Inc. All rights reserved.</p>
      <p>
        Redistribution and use in source and binary forms, with or without
        modification, are<br />
        permitted provided that the following conditions are met:
      </p>
      <p>
        1.Redistributions of source code must retain the above copyright notice,
        this list of conditions and the following disclaimer.
      </p>
      <p>
        2.Redistributions in binary form must reproduce the above copyright
        notice, this list of conditions and the following disclaimer in the
        documentation and/or other materials provided with the distribution.
      </p>
      <p>
        THIS SOFTWARE IS PROVIDED BY GOOGLE, INC. ``AS IS’’ AND ANY EXPRESS OR
        IMPLIED<br />
        WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
        MERCHANTABILITY AND<br />
        FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL
        GOOGLE, INC. OR<br />
        CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
        EXEMPLARY, OR<br />
        CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
        SUBSTITUTE GOODS OR<br />
        SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
        HOWEVER CAUSED AND ON<br />
        ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
        (INCLUDING<br />
        NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
        SOFTWARE, EVEN IF<br />
        ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
      </p>
      <p>
        The views and conclusions contained in the software and documentation
        are those of the<br />
        authors and should not be interpreted as representing official policies,
        either expressed<br />
        or implied, of Google, Inc.
      </p>
      <p>License for third_party/disklrucache:</p>
      <p>
        Copyright 2012 Jake Wharton<br />
        Copyright 2011 The Android Open Source Project
      </p>
      <p>
        Licensed under the Apache License, Version 2.0 (the “License”);<br />
        you may not use this file except in compliance with the License.<br />
        You may obtain a copy of the License at
      </p>
      <p>
        <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank"
          >http://www.apache.org/licenses/LICENSE-2.0</a
        >
      </p>
      <p>
        Unless required by applicable law or agreed to in writing, software<br />
        distributed under the License is distributed on an “AS IS” BASIS,<br />
        WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
        implied.<br />
        See the License for the specific language governing permissions and<br />
        limitations under the License.
      </p>
      <p>License for third_party/gif_decoder:</p>
      <p>Copyright © 2013 Xcellent Creations, Inc.</p>
      <p>
        Permission is hereby granted, free of charge, to any person obtaining<br />
        a copy of this software and associated documentation files (the<br />
        “Software”), to deal in the Software without restriction, including<br />
        without limitation the rights to use, copy, modify, merge, publish,<br />
        distribute, sublicense, and/or sell copies of the Software, and to<br />
        permit persons to whom the Software is furnished to do so, subject to<br />
        the following conditions:
      </p>
      <p>
        The above copyright notice and this permission notice shall be<br />
        included in all copies or substantial portions of the Software.
      </p>
      <p>
        THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND,<br />
        EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF<br />
        MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND<br />
        NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
        BE<br />
        LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
        ACTION<br />
        OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION<br />
        WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
      </p>
      <p>
        License for third_party/gif_encoder/AnimatedGifEncoder.java and<br />
        third_party/gif_encoder/LZWEncoder.java:
      </p>
      <p>
        No copyright asserted on the source code of this class. May be used for
        any<br />
        purpose, however, refer to the Unisys LZW patent for restrictions on use
        of<br />
        the associated LZWEncoder class. Please forward any corrections to<br />
        <a href="mailto:kweiner@fmsware.com" target="_blank"
          >kweiner@fmsware.com</a
        >.
      </p>
      <hr />
      <p>License for third_party/gif_encoder/NeuQuant.java</p>
      <p>Copyright © 1994 Anthony Dekker</p>
      <p>
        NEUQUANT Neural-Net quantization algorithm by Anthony Dekker, 1994.
        See<br />
        “Kohonen neural networks for optimal colour quantization” in
        “Network:<br />
        Computation in Neural Systems” Vol. 5 (1994) pp 351-367. for a
        discussion of<br />
        the algorithm.
      </p>
      <p>
        Any party obtaining a copy of these files from the author, directly
        or<br />
        indirectly, is granted, free of charge, a full and unrestricted
        irrevocable,<br />
        world-wide, paid up, royalty-free, nonexclusive right and license to
        deal in<br />
        this software and documentation files (the “Software”), including
        without<br />
        limitation the rights to use, copy, modify, merge, publish,
        distribute,<br />
        sublicense, and/or sell copies of the Software, and to permit persons
        who<br />
        receive copies from any such party to do so, with the only requirement
        being<br />
        that this copyright notice remain intact.
      </p>
      <h1><a id="EventBus_485"></a>EventBus</h1>
      <p>
        Copyright © 2012-2021 Markus Junginger, greenrobot (<a
          href="https://greenrobot.org/"
          target="_blank"
          >https://greenrobot.org</a
        >)
      </p>
      <p>
        EventBus binaries and source code can be used according to the
        <a
          href="https://github.com/greenrobot/EventBus/blob/master/LICENSE"
          target="_blank"
          >Apache License, Version 2.0</a
        >.
      </p>
      <h1><a id="EasyPermissions_491"></a>EasyPermissions</h1>
      <p>Copyright 2017 Google</p>
      <p>
        Licensed under the Apache License, Version 2.0 (the “License”);<br />
        you may not use this file except in compliance with the License.<br />
        You may obtain a copy of the License at
      </p>
      <p>
        <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank"
          >http://www.apache.org/licenses/LICENSE-2.0</a
        >
      </p>
      <p>
        Unless required by applicable law or agreed to in writing, software<br />
        distributed under the License is distributed on an “AS IS” BASIS,<br />
        WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
        implied.<br />
        See the License for the specific language governing permissions and<br />
        limitations under the License.
      </p>
      <h1>
        <a id="RecyclerViewFlexibleDivider_507"></a>RecyclerView-FlexibleDivider
      </h1>
      <p>Copyright 2016 yqritc</p>
      <p>
        Licensed under the Apache License, Version 2.0 (the “License”);<br />
        you may not use this file except in compliance with the License.<br />
        You may obtain a copy of the License at
      </p>
      <p>
        <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank"
          >http://www.apache.org/licenses/LICENSE-2.0</a
        >
      </p>
      <p>
        Unless required by applicable law or agreed to in writing, software<br />
        distributed under the License is distributed on an “AS IS” BASIS,<br />
        WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
        implied.<br />
        See the License for the specific language governing permissions and<br />
        limitations under the License.
      </p>
      <h1><a id="SmartRefreshLayout_523"></a>SmartRefreshLayout</h1>
      <p>Copyright 2017 scwang90</p>
      <p>
        Licensed under the Apache License, Version 2.0 (the “License”);<br />
        you may not use this file except in compliance with the License.<br />
        You may obtain a copy of the License at
      </p>
      <p>
        <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank"
          >http://www.apache.org/licenses/LICENSE-2.0</a
        >
      </p>
      <p>
        Unless required by applicable law or agreed to in writing, software<br />
        distributed under the License is distributed on an “AS IS” BASIS,<br />
        WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
        implied.<br />
        See the License for the specific language governing permissions and<br />
        limitations under the License.
      </p>
      <h1><a id="JKeyboardPanelSwitch_539"></a>JKeyboardPanelSwitch</h1>
      <p>Copyright 2015 Jacks gong.</p>
      <p>
        Licensed under the Apache License, Version 2.0 (the “License”);<br />
        you may not use this file except in compliance with the License.<br />
        You may obtain a copy of the License at
      </p>
      <p>
        <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank"
          >http://www.apache.org/licenses/LICENSE-2.0</a
        >
      </p>
      <p>
        Unless required by applicable law or agreed to in writing, software<br />
        distributed under the License is distributed on an “AS IS” BASIS,<br />
        WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
        implied.<br />
        See the License for the specific language governing permissions and<br />
        limitations under the License.
      </p>
      <h1><a id="LZ4_Java_555"></a>LZ4 Java</h1>
      <p>Copyright 2020 Adrien Grand and the lz4-java contributors.</p>
      <p>Licensed under the Apache License, Version 2.0 (the “License”);</p>
      <p>you may not use this file except in compliance with the License.</p>
      <p>You may obtain a copy of the License at</p>
      <p>
        <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank"
          >http://www.apache.org/licenses/LICENSE-2.0</a
        >
      </p>
      <p>Unless required by applicable law or agreed to in writing, software</p>
      <p>distributed under the License is distributed on an “AS IS” BASIS,</p>
      <p>
        WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      </p>
      <p>See the License for the specific language governing permissions and</p>
      <p>limitations under the License.</p>
      <h1>
        <a id="Subsampling_Scale_Image_View_577"></a>Subsampling Scale Image
        View
      </h1>
      <p>
        Copyright 2018 David Morrissey, and licensed under the Apache License,
        Version 2.0.
      </p>
      <h1><a id="StringFog_581"></a>StringFog</h1>
      <p>Copyright © 2016-2023, Megatron King</p>
      <p>
        Licensed under the Apache License, Version 2.0 (the “License”);<br />
        you may not use this file except in compliance with the License.<br />
        You may obtain a copy of the License at
      </p>
      <p>
        <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank"
          >http://www.apache.org/licenses/LICENSE-2.0</a
        >
      </p>
      <p>
        Unless required by applicable law or agreed to in writing, software<br />
        distributed under the License is distributed on an “AS IS” BASIS,<br />
        WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
        implied.<br />
        See the License for the specific language governing permissions and<br />
        limitations under the License.
      </p>
      <h1><a id="zxing_597"></a>zxing</h1>
      <p>Copyright © 2012 ZXing authors</p>
      <p>Licensed under the Apache License, Version 2.0 (the “License”);</p>
      <p>you may not use this file except in compliance with the License.</p>
      <p>You may obtain a copy of the License at</p>
      <p>
        <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank"
          >http://www.apache.org/licenses/LICENSE-2.0</a
        >
      </p>
      <p>Unless required by applicable law or agreed to in writing, software</p>
      <p>distributed under the License is distributed on an “AS IS” BASIS,</p>
      <p>
        WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      </p>
      <p>See the License for the specific language governing permissions and</p>
      <p>limitations under the License.</p>
      <h1><a id="Android_flow_layout_619"></a>Android flow layout</h1>
      <p>Copyright 2011, Artem Votincev (apmem.org)</p>
      <p>
        Licensed under the Apache License, Version 2.0 (the “License”); you may
        not use this file except in compliance with the License. You may obtain
        a copy of the License at
      </p>
      <p>
        <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank"
          >http://www.apache.org/licenses/LICENSE-2.0</a
        >
      </p>
      <p>
        Unless required by applicable law or agreed to in writing, software
        distributed under the License is distributed on an “AS IS” BASIS,
        WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
        See the License for the specific language governing permissions and
        limitations under the License.
      </p>
      <h1><a id="Toaster_629"></a>Toaster</h1>
      <p>Copyright 2018 Huang JinQun</p>
      <p>
        Licensed under the Apache License, Version 2.0 (the “License”);<br />
        you may not use this file except in compliance with the License.<br />
        You may obtain a copy of the License at
      </p>
      <p>
        <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank"
          >http://www.apache.org/licenses/LICENSE-2.0</a
        >
      </p>
      <p>
        Unless required by applicable law or agreed to in writing, software<br />
        distributed under the License is distributed on an “AS IS” BASIS,<br />
        WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
        implied.<br />
        See the License for the specific language governing permissions and<br />
        limitations under the License.
      </p>
      <h1><a id="butterknife_645"></a>butterknife</h1>
      <p>Copyright 2013 Jake Wharton</p>
      <p>
        Licensed under the Apache License, Version 2.0 (the “License”);<br />
        you may not use this file except in compliance with the License.<br />
        You may obtain a copy of the License at
      </p>
      <p>
        <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank"
          >http://www.apache.org/licenses/LICENSE-2.0</a
        >
      </p>
      <p>
        Unless required by applicable law or agreed to in writing, software<br />
        distributed under the License is distributed on an “AS IS” BASIS,<br />
        WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
        implied.<br />
        See the License for the specific language governing permissions and<br />
        limitations under the License.
      </p>
      <h1><a id="Snappy_661"></a>Snappy</h1>
      <p>
        Copyright © 2011 the original author or authors.<br />
        See the notice.md file distributed with this work for additional<br />
        information regarding copyright ownership.
      </p>
      <p>
        Licensed under the Apache License, Version 2.0 (the “License”);<br />
        you may not use this file except in compliance with the License.<br />
        You may obtain a copy of the License at
      </p>
      <p>
        <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank"
          >http://www.apache.org/licenses/LICENSE-2.0</a
        >
      </p>
      <p>
        Unless required by applicable law or agreed to in writing, software<br />
        distributed under the License is distributed on an “AS IS” BASIS,<br />
        WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
        implied.<br />
        See the License for the specific language governing permissions and<br />
        limitations under the License.
      </p>
      <h1><a id="MagicIndicator_679"></a>MagicIndicator</h1>
      <p>MIT License</p>
      <p>Copyright © 2016 hackware1993</p>
      <p>
        Permission is hereby granted, free of charge, to any person obtaining a
        copy<br />
        of this software and associated documentation files (the “Software”), to
        deal<br />
        in the Software without restriction, including without limitation the
        rights<br />
        to use, copy, modify, merge, publish, distribute, sublicense, and/or
        sell<br />
        copies of the Software, and to permit persons to whom the Software is<br />
        furnished to do so, subject to the following conditions:
      </p>
      <p>
        The above copyright notice and this permission notice shall be included
        in all<br />
        copies or substantial portions of the Software.
      </p>
      <p>
        THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS
        OR<br />
        IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
        MERCHANTABILITY,<br />
        FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
        THE<br />
        AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
        OTHER<br />
        LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
        FROM,<br />
        OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
        IN THE<br />
        SOFTWARE.
      </p>
      <h1><a id="RichText_703"></a>RichText</h1>
      <p>The MIT License (MIT)</p>
      <p>Copyright © 2016 zzhoujay</p>
      <p>
        Permission is hereby granted, free of charge, to any person obtaining a
        copy<br />
        of this software and associated documentation files (the “Software”), to
        deal<br />
        in the Software without restriction, including without limitation the
        rights<br />
        to use, copy, modify, merge, publish, distribute, sublicense, and/or
        sell<br />
        copies of the Software, and to permit persons to whom the Software is<br />
        furnished to do so, subject to the following conditions:
      </p>
      <p>
        The above copyright notice and this permission notice shall be included
        in all<br />
        copies or substantial portions of the Software.
      </p>
      <p>
        THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS
        OR
      </p>
      <p>
        IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
        MERCHANTABILITY,<br />
        FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
        THE<br />
        AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
        OTHER<br />
        LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
        FROM,<br />
        OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
        IN THE<br />
        SOFTWARE.
      </p>
      <h1><a id="_728"></a></h1>
      <h1><a id="SimpleRatingBar_730"></a>SimpleRatingBar</h1>
      <p>MIT License</p>
      <p>Copyright © 2019 WilliamYu</p>
      <p>
        Permission is hereby granted, free of charge, to any person obtaining a
        copy<br />
        of this software and associated documentation files (the “Software”), to
        deal<br />
        in the Software without restriction, including without limitation the
        rights<br />
        to use, copy, modify, merge, publish, distribute, sublicense, and/or
        sell<br />
        copies of the Software, and to permit persons to whom the Software is<br />
        furnished to do so, subject to the following conditions:
      </p>
      <p>
        The above copyright notice and this permission notice shall be included
        in all<br />
        copies or substantial portions of the Software.
      </p>
      <p>
        THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS
        OR<br />
        IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
        MERCHANTABILITY,<br />
        FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
        THE<br />
        AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
        OTHER<br />
        LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
        FROM,<br />
        OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
        IN THE<br />
        SOFTWARE.
      </p>
      <h1><a id="RWidgetHelper_754"></a>RWidgetHelper</h1>
      <p>MIT License</p>
      <p>Copyright © 2018 Ruffian-痞子</p>
      <h1><a id="jsoup_760"></a>jsoup</h1>
      <p>The MIT License</p>
      <p>
        Copyright © 2009-2024 Jonathan Hedley &lt;<a
          href="https://jsoup.org/"
          target="_blank"
          >https://jsoup.org/</a
        >&gt;
      </p>
      <p>
        Permission is hereby granted, free of charge, to any person obtaining a
        copy<br />
        of this software and associated documentation files (the “Software”), to
        deal<br />
        in the Software without restriction, including without limitation the
        rights<br />
        to use, copy, modify, merge, publish, distribute, sublicense, and/or
        sell<br />
        copies of the Software, and to permit persons to whom the Software is<br />
        furnished to do so, subject to the following conditions:
      </p>
      <p>
        The above copyright notice and this permission notice shall be included
        in all<br />
        copies or substantial portions of the Software.
      </p>
      <p>
        THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS
        OR<br />
        IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
        MERCHANTABILITY,<br />
        FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
        THE<br />
        AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
        OTHER<br />
        LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
        FROM,<br />
        OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
        IN THE<br />
        SOFTWARE.
      </p>
      <h1><a id="Protocol_Buffers_784"></a>Protocol Buffers</h1>
      <p>Copyright 2008 Google Inc. All rights reserved.</p>
      <p>
        Redistribution and use in source and binary forms, with or without<br />
        modification, are permitted provided that the following conditions
        are<br />
        met:
      </p>
      <p>
        * Redistributions of source code must retain the above copyright<br />
        notice, this list of conditions and the following disclaimer.<br />
        * Redistributions in binary form must reproduce the above<br />
        copyright notice, this list of conditions and the following
        disclaimer<br />
        in the documentation and/or other materials provided with the<br />
        distribution.<br />
        * Neither the name of Google Inc. nor the names of its<br />
        contributors may be used to endorse or promote products derived from<br />
        this software without specific prior written permission.
      </p>
      <p>
        THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS<br />
        “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT<br />
        LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR<br />
        A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT<br />
        OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,<br />
        SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT<br />
        LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,<br />
        DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY<br />
        THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT<br />
        (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE<br />
        OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
      </p>
      <p>
        Code generated by the Protocol Buffer compiler is owned by the owner<br />
        of the input file used when generating it. This code is not<br />
        standalone and requires a support library to be linked with it. This<br />
        support library is itself covered by the above license.
      </p>
      <h2><a id="Conceal_819"></a>Conceal</h2>
      <p>BSD License</p>
      <p>For Conceal software</p>
      <p>Copyright © 2014, Facebook, Inc. All rights reserved.</p>
      <p>
        Redistribution and use in source and binary forms, with or without
        modification,<br />
        are permitted provided that the following conditions are met:
      </p>
      <p>
        * Redistributions of source code must retain the above copyright notice,
        this<br />
        list of conditions and the following disclaimer.
      </p>
      <p>
        * Redistributions in binary form must reproduce the above copyright
        notice,<br />
        this list of conditions and the following disclaimer in the
        documentation<br />
        and/or other materials provided with the distribution.
      </p>
      <p>
        * Neither the name Facebook nor the names of its contributors may be
        used to<br />
        endorse or promote products derived from this software without
        specific<br />
        prior written permission.
      </p>
      <p>
        THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS
        IS” AND<br />
        ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
        IMPLIED<br />
        WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
        ARE<br />
        DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
        LIABLE FOR<br />
        ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
        DAMAGES<br />
        (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
        SERVICES;<br />
        LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED
        AND ON<br />
        ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR
        TORT<br />
        (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
        THIS<br />
        SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
      </p>
      <h1><a id="xCrash_852"></a>xCrash</h1>
      <p>Copyright © 2019-present, iQIYI, Inc. All rights reserved.</p>
      <p>
        Most source code in xCrash are MIT licensed. Some other source code<br />
        have been placed in the public domain, or have BSD-style licenses.
      </p>
      <p>A copy of the MIT License is included in this file.</p>
      <p>
        Source code have been placed in the public domain<br />
        =================================================
      </p>
      <p>1. LZMA</p>
      <p>LZMA SDK is written and placed in the public domain by Igor Pavlov.</p>
      <p>
        Some code in LZMA SDK is based on public domain code from another
        developers:<br />
        1) PPMd var.H (2001): Dmitry Shkarin<br />
        2) SHA-256: Wei Dai (Crypto++ library)
      </p>
      <p>
        Anyone is free to copy, modify, publish, use, compile, sell, or
        distribute the<br />
        original LZMA SDK code, either in source code form or as a compiled
        binary, for<br />
        any purpose, commercial or non-commercial, and by any means.
      </p>
      <p>
        LZMA SDK code is compatible with open source licenses, for example, you
        can<br />
        include it to GNU GPL or GNU LGPL code.
      </p>
      <p>2. MD5</p>
      <p>
        This is an OpenSSL-compatible implementation of the RSA Data Security,
        Inc.<br />
        MD5 Message-Digest Algorithm (RFC 1321).
      </p>
      <p>
        Homepage:<br />
        <a
          href="http://openwall.info/wiki/people/solar/software/public-domain-source-code/md5"
          target="_blank"
          >http://openwall.info/wiki/people/solar/software/public-domain-source-code/md5</a
        >
      </p>
      <p>
        Author:<br />
        Alexander Peslyak, better known as Solar Designer &lt;solar at
        openwall.com&gt;
      </p>
      <p>
        This software was written by Alexander Peslyak in 2001. No copyright
        is<br />
        claimed, and the software is hereby placed in the public domain.<br />
        In case this attempt to disclaim copyright and place the software in
        the<br />
        public domain is deemed null and void, then the software is<br />
        Copyright © 2001 Alexander Peslyak and it is hereby released to the<br />
        general public under the following terms:
      </p>
      <p>
        Redistribution and use in source and binary forms, with or without<br />
        modification, are permitted.
      </p>
      <p>There’s ABSOLUTELY NO WARRANTY, express or implied.</p>
      <p>See md5.c for more information.</p>
      <p>
        Source code Licensed under the BSD 2-Clause License<br />
        ===================================================
      </p>
      <p>tree.h</p>
      <p>
        Copyright 2002 Niels Provos &lt;<a
          href="mailto:provos@citi.umich.edu"
          target="_blank"
          >provos@citi.umich.edu</a
        >&gt;<br />
        All rights reserved.
      </p>
      <p>
        Redistribution and use in source and binary forms, with or without<br />
        modification, are permitted provided that the following conditions<br />
        are met:<br />
        1. Redistributions of source code must retain the above copyright<br />
        notice, this list of conditions and the following disclaimer.<br />
        2. Redistributions in binary form must reproduce the above copyright<br />
        notice, this list of conditions and the following disclaimer in the<br />
        documentation and/or other materials provided with the distribution.<br />
        <br />
        THIS SOFTWARE IS PROVIDED BY THE AUTHOR ``AS IS’’ AND ANY EXPRESS OR<br />
        IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
        WARRANTIES<br />
        OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
        DISCLAIMED.<br />
        IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY DIRECT, INDIRECT,<br />
        INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
        BUT<br />
        NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF
        USE,<br />
        DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY<br />
        THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT<br />
        (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
        OF<br />
        THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
      </p>
      <p>
        Source code Licensed under the BSD 3-Clause License<br />
        ===================================================
      </p>
      <p>queue.h</p>
      <p>
        Copyright © 1991, 1993 The Regents of the University of California.<br />
        All rights reserved.
      </p>
      <p>
        Redistribution and use in source and binary forms, with or without<br />
        modification, are permitted provided that the following conditions<br />
        are met:<br />
        1. Redistributions of source code must retain the above copyright<br />
        notice, this list of conditions and the following disclaimer.<br />
        2. Redistributions in binary form must reproduce the above copyright<br />
        notice, this list of conditions and the following disclaimer in the<br />
        documentation and/or other materials provided with the distribution.<br />
        3. Neither the name of the University nor the names of its
        contributors<br />
        may be used to endorse or promote products derived from this software<br />
        without specific prior written permission.<br />
        <br />
        THIS SOFTWARE IS PROVIDED BY THE REGENTS AND CONTRIBUTORS ``AS IS’’
        AND<br />
        ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE<br />
        IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
        PURPOSE<br />
        ARE DISCLAIMED. IN NO EVENT SHALL THE REGENTS OR CONTRIBUTORS BE
        LIABLE<br />
        FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
        CONSEQUENTIAL<br />
        DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
        GOODS<br />
        OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)<br />
        HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
        STRICT<br />
        LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY
        WAY<br />
        OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY
        OF<br />
        SUCH DAMAGE.
      </p>
      <p>
        Terms of the MIT License<br />
        ========================
      </p>
      <p>
        Permission is hereby granted, free of charge, to any person obtaining a
        copy<br />
        of this software and associated documentation files (the “Software”), to
        deal<br />
        in the Software without restriction, including without limitation the
        rights<br />
        to use, copy, modify, merge, publish, distribute, sublicense, and/or
        sell<br />
        copies of the Software, and to permit persons to whom the Software is<br />
        furnished to do so, subject to the following conditions:
      </p>
      <p>
        The above copyright notice and this permission notice shall be included
        in all<br />
        copies or substantial portions of the Software.
      </p>
      <p>
        THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS
        OR<br />
        IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
        MERCHANTABILITY,<br />
        FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
        THE<br />
        AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
        OTHER<br />
        LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
        FROM,<br />
        OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
        IN THE<br />
        SOFTWARE.
      </p>
      <h1><a id="FFmpeg_985"></a>FFmpeg</h1>
      <p>
        Official site:
        <a href="https://www.ffmpeg.org" target="_blank"
          >https://www.ffmpeg.org</a
        >
      </p>
      <p>
        Modified version:
        <a
          href="https://github.com/MJPaintStudio/ffmpeg-mjpaint"
          target="_blank"
          >https://github.com/MJPaintStudio/ffmpeg-mjpaint</a
        >
      </p>
      <p>Copyright © FFmpeg developers and contributers</p>
      <p>Licensed under LGPLv2.1 or later</p>
      <h1><a id="UpdatePlugin_995"></a>UpdatePlugin</h1>
      <p>Copyright © 2017 Haoge</p>
      <p>Licensed under the Apache License, Version 2.0 (the “License”);</p>
      <p>you may not use this file except in compliance with the License.</p>
      <p>You may obtain a copy of the License at</p>
      <p>
        <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank"
          >http://www.apache.org/licenses/LICENSE-2.0</a
        >
      </p>
      <p>Unless required by applicable law or agreed to in writing, software</p>
      <p>distributed under the License is distributed on an “AS IS” BASIS,</p>
      <p>
        WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      </p>
      <p>See the License for the specific language governing permissions and</p>
      <p>limitations under the License.</p>
      <h1><a id="lombok_1017"></a>lombok</h1>
      <p>Copyright © 2009-2015 The Project Lombok Authors.</p>
      <p>
        Permission is hereby granted, free of charge, to any person obtaining a
        copy<br />
        of this software and associated documentation files (the “Software”), to
        deal<br />
        in the Software without restriction, including without limitation the
        rights<br />
        to use, copy, modify, merge, publish, distribute, sublicense, and/or
        sell<br />
        copies of the Software, and to permit persons to whom the Software is<br />
        furnished to do so, subject to the following conditions:
      </p>
      <p>
        The above copyright notice and this permission notice shall be included
        in<br />
        all copies or substantial portions of the Software.
      </p>
      <p>
        THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS
        OR<br />
        IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
        MERCHANTABILITY,<br />
        FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
        THE<br />
        AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
        OTHER<br />
        LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
        FROM,<br />
        OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
        IN<br />
        THE SOFTWARE.
      </p>
      <h1><a id="AndriodVideoCache_1039"></a>AndriodVideoCache</h1>
      <p>Copyright 2014-2017 Alexey Danilov</p>
      <p>
        Licensed under the Apache License, Version 2.0 (the “License”);<br />
        you may not use this file except in compliance with the License.<br />
        You may obtain a copy of the License at
      </p>
      <p>
        <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank"
          >http://www.apache.org/licenses/LICENSE-2.0</a
        >
      </p>
      <p>
        Unless required by applicable law or agreed to in writing, software<br />
        distributed under the License is distributed on an “AS IS” BASIS,<br />
        WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
        implied.<br />
        See the License for the specific language governing permissions and<br />
        limitations under the License.
      </p>
      <h1><a id="PlayerBase_1055"></a>PlayerBase</h1>
      <p>
        Copyright 2017 jiajunhui<a
          href="mailto:junhui_jia@163.com"
          target="_blank"
          >junhui_jia@163.com</a
        >
      </p>
      <p>
        Licensed under the Apache License, Version 2.0 (the “License”);<br />
        you may not use this file except in compliance with the License.<br />
        You may obtain a copy of the License at
      </p>
      <p>
        <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank"
          >http://www.apache.org/licenses/LICENSE-2.0</a
        >
      </p>
      <p>
        Unless required by applicable law or agreed to in writing, software<br />
        distributed under the License is distributed on an “AS IS” BASIS,<br />
        WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
        implied.<br />
        See the License for the specific language governing permissions and<br />
        limitations under the License.
      </p>
      <h1><a id="ShadowLayout_1071"></a>ShadowLayout</h1>
      <p>MIT License</p>
      <p>Copyright © 2019 leo</p>
      <p>
        Permission is hereby granted, free of charge, to any person obtaining a
        copy<br />
        of this software and associated documentation files (the “Software”), to
        deal<br />
        in the Software without restriction, including without limitation the
        rights<br />
        to use, copy, modify, merge, publish, distribute, sublicense, and/or
        sell<br />
        copies of the Software, and to permit persons to whom the Software is<br />
        furnished to do so, subject to the following conditions:
      </p>
      <p>
        The above copyright notice and this permission notice shall be included
        in all<br />
        copies or substantial portions of the Software.
      </p>
      <h1><a id="slf4j_1087"></a>slf4j</h1>
      <p>
        Copyright © 2004-2022 QOS.ch Sarl (Switzerland)<br />
        All rights reserved.
      </p>
      <p>
        Permission is hereby granted, free of charge, to any person obtaining<br />
        a copy of this software and associated documentation files (the<br />
        “Software”), to deal in the Software without restriction, including<br />
        without limitation the rights to use, copy, modify, merge, publish,<br />
        distribute, sublicense, and/or sell copies of the Software, and to<br />
        permit persons to whom the Software is furnished to do so, subject to<br />
        the following conditions:
      </p>
      <p>
        The above copyright notice and this permission notice shall be<br />
        included in all copies or substantial portions of the Software.
      </p>
      <p>
        THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND,<br />
        EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF<br />
        MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND<br />
        NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
        BE<br />
        LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
        ACTION<br />
        OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION<br />
        WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
      </p>
      <h1><a id="uCrop_1111"></a>uCrop</h1>
      <p>Copyright 2017, Yalantis</p>
      <p>
        Licensed under the Apache License, Version 2.0 (the “License”);<br />
        you may not use this file except in compliance with the License.<br />
        You may obtain a copy of the License at
      </p>
      <p>
        <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank"
          >http://www.apache.org/licenses/LICENSE-2.0</a
        >
      </p>
      <p>
        Unless required by applicable law or agreed to in writing, software<br />
        distributed under the License is distributed on an “AS IS” BASIS,<br />
        WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
        implied.<br />
        See the License for the specific language governing permissions and<br />
        limitations under the License.
      </p>
      <h1><a id="libwebp_1128"></a>libwebp</h1>
      <p>
        Copyright © 2010, Google Inc. All rights reserved.<br />
        Redistribution and use in source and binary forms, with or without<br />
        modification, are permitted provided that the following conditions
        are<br />
        met:
      </p>
      <ul>
        <li>
          Redistributions of source code must retain the above copyright<br />
          notice, this list of conditions and the following disclaimer.
        </li>
        <li>
          Redistributions in binary form must reproduce the above copyright<br />
          notice, this list of conditions and the following disclaimer in<br />
          the documentation and/or other materials provided with the<br />
          distribution.
        </li>
        <li>
          Neither the name of Google nor the names of its contributors may<br />
          be used to endorse or promote products derived from this software<br />
          without specific prior written permission.<br />
          THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS<br />
          “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT<br />
          LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
          FOR<br />
          A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
          COPYRIGHT<br />
          HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
          INCIDENTAL,<br />
          SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT<br />
          LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF
          USE,<br />
          DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
          ANY<br />
          THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT<br />
          (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE
          USE<br />
          OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
          DAMAGE.<br />
          Additional IP Rights Grant (Patents)
        </li>
      </ul>
      <hr />
      <p>
        “These implementations” means the copyrightable works that implement the
        WebM<br />
        codecs distributed by Google as part of the WebM Project.<br />
        Google hereby grants to you a perpetual, worldwide, non-exclusive,
        no-charge,<br />
        royalty-free, irrevocable (except as stated in this section) patent
        license to<br />
        make, have made, use, offer to sell, sell, import, transfer, and
        otherwise<br />
        run, modify and propagate the contents of these implementations of WebM,
        where<br />
        such license applies only to those patent claims, both currently owned
        by<br />
        Google and acquired in the future, licensable by Google that are
        necessarily<br />
        infringed by these implementations of WebM. This grant does not include
        claims<br />
        that would be infringed only as a consequence of further modification of
        these<br />
        implementations. If you or your agent or exclusive licensee institute or
        order<br />
        or agree to the institution of patent litigation or any other patent<br />
        enforcement activity against any entity (including a cross-claim or<br />
        counterclaim in a lawsuit) alleging that any of these implementations of
        WebM<br />
        or any code incorporated within any of these implementations of WebM<br />
        constitute direct or contributory patent infringement, or inducement
        of<br />
        patent infringement, then any patent rights granted to you under this
        License<br />
        for these implementations of WebM shall terminate as of the date such<br />
        litigation is filed.
      </p>
      <h1><a id="libcxx_1177"></a>libcxx</h1>
      <p>
        ==============================================================================<br />
        libc++ License<br />
        ==============================================================================
      </p>
      <p>
        University of Illinois/NCSA<br />
        Open Source License
      </p>
      <p>Copyright © 2009-2012 by the contributors listed in CREDITS.TXT</p>
      <p>All rights reserved.</p>
      <p>Developed by:</p>
      <code>LLVM Team University of Illinois at Urbana-Champaign http://llvm.org </code>
      <p>
        Permission is hereby granted, free of charge, to any person obtaining a
        copy of<br />
        this software and associated documentation files (the “Software”), to
        deal with<br />
        the Software without restriction, including without limitation the
        rights to<br />
        use, copy, modify, merge, publish, distribute, sublicense, and/or sell
        copies<br />
        of the Software, and to permit persons to whom the Software is furnished
        to do<br />
        so, subject to the following conditions:
      </p>
      <code>* Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimers. * Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimers in the documentation and/or other materials provided with the distribution. * Neither the names of the LLVM Team, University of Illinois at Urbana-Champaign, nor the names of its contributors may be used to endorse or promote products derived from this Software without specific prior written permission. </code>
      <p>
        THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS
        OR<br />
        IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
        FITNESS<br />
        FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
        CONTRIBUTORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
        OTHER<br />
        LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
        FROM,<br />
        OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
        WITH THE<br />
        SOFTWARE.
      </p>
      <h1><a id="libcxxabi_1225"></a>libcxxabi</h1>
      <p>
        ==============================================================================<br />
        The LLVM Project is under the Apache License v2.0 with LLVM
        Exceptions:<br />
        =======================================================================
      </p>
      <code> Apache License Version 2.0, January 2004 http://www.apache.org/licenses/ TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION 1. Definitions. &quot;License&quot; shall mean the terms and conditions for use, reproduction, and distribution as defined by Sections 1 through 9 of this document. &quot;Licensor&quot; shall mean the copyright owner or entity authorized by the copyright owner that is granting the License. &quot;Legal Entity&quot; shall mean the union of the acting entity and all other entities that control, are controlled by, or are under common control with that entity. For the purposes of this definition, &quot;control&quot; means (i) the power, direct or indirect, to cause the direction or management of such entity, whether by contract or otherwise, or (ii) ownership of fifty percent (50%) or more of the outstanding shares, or (iii) beneficial ownership of such entity. &quot;You&quot; (or &quot;Your&quot;) shall mean an individual or Legal Entity exercising permissions granted by this License. &quot;Source&quot; form shall mean the preferred form for making modifications, including but not limited to software source code, documentation source, and configuration files. &quot;Object&quot; form shall mean any form resulting from mechanical transformation or translation of a Source form, including but not limited to compiled object code, generated documentation, and conversions to other media types. &quot;Work&quot; shall mean the work of authorship, whether in Source or Object form, made available under the License, as indicated by a copyright notice that is included in or attached to the work (an example is provided in the Appendix below). &quot;Derivative Works&quot; shall mean any work, whether in Source or Object form, that is based on (or derived from) the Work and for which the editorial revisions, annotations, elaborations, or other modifications represent, as a whole, an original work of authorship. For the purposes of this License, Derivative Works shall not include works that remain separable from, or merely link (or bind by name) to the interfaces of, the Work and Derivative Works thereof. &quot;Contribution&quot; shall mean any work of authorship, including the original version of the Work and any modifications or additions to that Work or Derivative Works thereof, that is intentionally submitted to Licensor for inclusion in the Work by the copyright owner or by an individual or Legal Entity authorized to submit on behalf of the copyright owner. For the purposes of this definition, &quot;submitted&quot; means any form of electronic, verbal, or written communication sent to the Licensor or its representatives, including but not limited to communication on electronic mailing lists, source code control systems, and issue tracking systems that are managed by, or on behalf of, the Licensor for the purpose of discussing and improving the Work, but excluding communication that is conspicuously marked or otherwise designated in writing by the copyright owner as &quot;Not a Contribution.&quot; &quot;Contributor&quot; shall mean Licensor and any individual or Legal Entity on behalf of whom a Contribution has been received by Licensor and subsequently incorporated within the Work. 2. Grant of Copyright License. Subject to the terms and conditions of this License, each Contributor hereby grants to You a perpetual, worldwide, non-exclusive, no-charge, royalty-free, irrevocable copyright license to reproduce, prepare Derivative Works of, publicly display, publicly perform, sublicense, and distribute the Work and such Derivative Works in Source or Object form. 3. Grant of Patent License. Subject to the terms and conditions of this License, each Contributor hereby grants to You a perpetual, worldwide, non-exclusive, no-charge, royalty-free, irrevocable (except as stated in this section) patent license to make, have made, use, offer to sell, sell, import, and otherwise transfer the Work, where such license applies only to those patent claims licensable by such Contributor that are necessarily infringed by their Contribution(s) alone or by combination of their Contribution(s) with the Work to which such Contribution(s) was submitted. If You institute patent litigation against any entity (including a cross-claim or counterclaim in a lawsuit) alleging that the Work or a Contribution incorporated within the Work constitutes direct or contributory patent infringement, then any patent licenses granted to You under this License for that Work shall terminate as of the date such litigation is filed. 4. Redistribution. You may reproduce and distribute copies of the Work or Derivative Works thereof in any medium, with or without modifications, and in Source or Object form, provided that You meet the following conditions: (a) You must give any other recipients of the Work or Derivative Works a copy of this License; and (b) You must cause any modified files to carry prominent notices stating that You changed the files; and (c) You must retain, in the Source form of any Derivative Works that You distribute, all copyright, patent, trademark, and attribution notices from the Source form of the Work, excluding those notices that do not pertain to any part of the Derivative Works; and (d) If the Work includes a &quot;NOTICE&quot; text file as part of its distribution, then any Derivative Works that You distribute must include a readable copy of the attribution notices contained within such NOTICE file, excluding those notices that do not pertain to any part of the Derivative Works, in at least one of the following places: within a NOTICE text file distributed as part of the Derivative Works; within the Source form or documentation, if provided along with the Derivative Works; or, within a display generated by the Derivative Works, if and wherever such third-party notices normally appear. The contents of the NOTICE file are for informational purposes only and do not modify the License. You may add Your own attribution notices within Derivative Works that You distribute, alongside or as an addendum to the NOTICE text from the Work, provided that such additional attribution notices cannot be construed as modifying the License. You may add Your own copyright statement to Your modifications and may provide additional or different license terms and conditions for use, reproduction, or distribution of Your modifications, or for any such Derivative Works as a whole, provided Your use, reproduction, and distribution of the Work otherwise complies with the conditions stated in this License. 5. Submission of Contributions. Unless You explicitly state otherwise, any Contribution intentionally submitted for inclusion in the Work by You to the Licensor shall be under the terms and conditions of this License, without any additional terms or conditions. Notwithstanding the above, nothing herein shall supersede or modify the terms of any separate license agreement you may have executed with Licensor regarding such Contributions. 6. Trademarks. This License does not grant permission to use the trade names, trademarks, service marks, or product names of the Licensor, except as required for reasonable and customary use in describing the origin of the Work and reproducing the content of the NOTICE file. 7. Disclaimer of Warranty. Unless required by applicable law or agreed to in writing, Licensor provides the Work (and each Contributor provides its Contributions) on an &quot;AS IS&quot; BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied, including, without limitation, any warranties or conditions of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A PARTICULAR PURPOSE. You are solely responsible for determining the appropriateness of using or redistributing the Work and assume any risks associated with Your exercise of permissions under this License. 8. Limitation of Liability. In no event and under no legal theory, whether in tort (including negligence), contract, or otherwise, unless required by applicable law (such as deliberate and grossly negligent acts) or agreed to in writing, shall any Contributor be liable to You for damages, including any direct, indirect, special, incidental, or consequential damages of any character arising as a result of this License or out of the use or inability to use the Work (including but not limited to damages for loss of goodwill, work stoppage, computer failure or malfunction, or any and all other commercial damages or losses), even if such Contributor has been advised of the possibility of such damages. 9. Accepting Warranty or Additional Liability. While redistributing the Work or Derivative Works thereof, You may choose to offer, and charge a fee for, acceptance of support, warranty, indemnity, or other liability obligations and/or rights consistent with this License. However, in accepting such obligations, You may act only on Your own behalf and on Your sole responsibility, not on behalf of any other Contributor, and only if You agree to indemnify, defend, and hold each Contributor harmless for any liability incurred by, or claims asserted against, such Contributor by reason of your accepting any such warranty or additional liability. END OF TERMS AND CONDITIONS APPENDIX: How to apply the Apache License to your work. To apply the Apache License to your work, attach the following boilerplate notice, with the fields enclosed by brackets &quot;[]&quot; replaced with your own identifying information. (Don't include the brackets!) The text should be enclosed in the appropriate comment syntax for the file format. We also recommend that a file or class name and description of purpose be included on the same &quot;printed page&quot; as the copyright notice for easier identification within third-party archives. Copyright [yyyy] [name of copyright owner] Licensed under the Apache License, Version 2.0 (the &quot;License&quot;); you may not use this file except in compliance with the License. You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0 Unless required by applicable law or agreed to in writing, software distributed under the License is distributed on an &quot;AS IS&quot; BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions and limitations under the License. </code>
      <p>---- LLVM Exceptions to the Apache 2.0 License ----</p>
      <p>
        As an exception, if, as a result of your compiling your source code,
        portions<br />
        of this Software are embedded into an Object form of such source code,
        you<br />
        may redistribute such embedded portions in such Object form without
        complying<br />
        with the conditions of Sections 4(a), 4(b) and 4(d) of the License.
      </p>
      <p>
        In addition, if you combine or link compiled forms of this Software
        with<br />
        software that is licensed under the GPLv2 (“Combined Software”) and if
        a<br />
        court of competent jurisdiction determines that the patent provision
        (Section<br />
        3), the indemnity provision (Section 9) or other Section of the
        License<br />
        conflicts with the conditions of the GPLv2, you may retroactively and<br />
        prospectively choose to deem waived or otherwise exclude such Section(s)
        of<br />
        the License, but only in their entirety and only with respect to the
        Combined<br />
        Software.
      </p>
      <p>
        ==============================================================================<br />
        Software from third parties included in the LLVM Project:<br />
        =========================================================
      </p>
      <p>
        The LLVM Project contains third party software which is under different
        license<br />
        terms. All such code will be identified clearly using at least one of
        two<br />
        mechanisms:
      </p>
      <ol>
        <li>
          It will be in a separate directory tree with its own
          <code>LICENSE.txt</code> or<br />
          <code>LICENSE</code> file at the top containing the specific license
          and restrictions<br />
          which apply to that software, or
        </li>
        <li>
          It will contain specific license and restriction terms at the top of
          every<br />
          file.
        </li>
      </ol>
      <p>
        ==============================================================================<br />
        Legacy LLVM License (<a
          href="https://llvm.org/docs/DeveloperPolicy.html#legacy"
          target="_blank"
          >https://llvm.org/docs/DeveloperPolicy.html#legacy</a
        >):<br />
        ==========================================================================
      </p>
      <p>
        The libc++abi library is dual licensed under both the University of
        Illinois<br />
        “BSD-Like” license and the MIT license. As a user of this code you may
        choose<br />
        to use it under either license. As a contributor, you agree to allow
        your code<br />
        to be used under both.
      </p>
      <p>Full text of the relevant licenses is included below.</p>
      <p>
        ==============================================================================
      </p>
      <p>
        University of Illinois/NCSA<br />
        Open Source License
      </p>
      <p>Copyright © 2009-2019 by the contributors listed in CREDITS.TXT</p>
      <p>All rights reserved.</p>
      <p>Developed by:</p>
      <code>LLVM Team University of Illinois at Urbana-Champaign http://llvm.org </code>
      <p>
        Permission is hereby granted, free of charge, to any person obtaining a
        copy of<br />
        this software and associated documentation files (the “Software”), to
        deal with<br />
        the Software without restriction, including without limitation the
        rights to<br />
        use, copy, modify, merge, publish, distribute, sublicense, and/or sell
        copies<br />
        of the Software, and to permit persons to whom the Software is furnished
        to do<br />
        so, subject to the following conditions:
      </p>
      <code>* Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimers. * Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimers in the documentation and/or other materials provided with the distribution. * Neither the names of the LLVM Team, University of Illinois at Urbana-Champaign, nor the names of its contributors may be used to endorse or promote products derived from this Software without specific prior written permission. </code>
      <p>
        THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS
        OR<br />
        IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
        FITNESS<br />
        FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
        CONTRIBUTORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
        OTHER<br />
        LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
        FROM,<br />
        OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
        WITH THE<br />
        SOFTWARE.
      </p>
      <p>
        ==============================================================================
      </p>
      <p>Copyright © 2009-2014 by the contributors listed in CREDITS.TXT</p>
      <p>
        Permission is hereby granted, free of charge, to any person obtaining a
        copy<br />
        of this software and associated documentation files (the “Software”), to
        deal<br />
        in the Software without restriction, including without limitation the
        rights<br />
        to use, copy, modify, merge, publish, distribute, sublicense, and/or
        sell<br />
        copies of the Software, and to permit persons to whom the Software is<br />
        furnished to do so, subject to the following conditions:
      </p>
      <p>
        The above copyright notice and this permission notice shall be included
        in<br />
        all copies or substantial portions of the Software.
      </p>
      <p>
        THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS
        OR<br />
        IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
        MERCHANTABILITY,<br />
        FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
        THE<br />
        AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
        OTHER<br />
        LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
        FROM,<br />
        OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
        IN<br />
        THE SOFTWARE.
      </p>
      <h1><a id="sourcehansans_1540"></a>source-han-sans</h1>
      <p>
        Copyright 2014-2021 Adobe (<a
          href="http://www.adobe.com/"
          target="_blank"
          >http://www.adobe.com/</a
        >), with Reserved Font<br />
        Name ‘Source’. Source is a trademark of Adobe in the United States<br />
        and/or other countries.
      </p>
      <p>
        This Font Software is licensed under the SIL Open Font License,<br />
        Version 1.1.
      </p>
      <p>
        This license is copied below, and is also available with a FAQ at:<br />
        <a href="http://scripts.sil.org/OFL" target="_blank"
          >http://scripts.sil.org/OFL</a
        >
      </p>
      <p>
        -----------------------------------------------------------<br />
        SIL OPEN FONT LICENSE Version 1.1 - 26 February 2007<br />
        -----------------------------------------------------------
      </p>
      <p>
        PREAMBLE<br />
        The goals of the Open Font License (OFL) are to stimulate worldwide<br />
        development of collaborative font projects, to support the font<br />
        creation efforts of academic and linguistic communities, and to<br />
        provide a free and open framework in which fonts may be shared and<br />
        improved in partnership with others.
      </p>
      <p>
        The OFL allows the licensed fonts to be used, studied, modified and<br />
        redistributed freely as long as they are not sold by themselves. The<br />
        fonts, including any derivative works, can be bundled, embedded,<br />
        redistributed and/or sold with any software provided that any
        reserved<br />
        names are not used by derivative works. The fonts and derivatives,<br />
        however, cannot be released under any other type of license. The<br />
        requirement for fonts to remain under this license does not apply to<br />
        any document created using the fonts or their derivatives.
      </p>
      <p>
        DEFINITIONS<br />
        “Font Software” refers to the set of files released by the Copyright<br />
        Holder(s) under this license and clearly marked as such. This may<br />
        include source files, build scripts and documentation.
      </p>
      <p>
        “Reserved Font Name” refers to any names specified as such after the<br />
        copyright statement(s).
      </p>
      <p>
        “Original Version” refers to the collection of Font Software<br />
        components as distributed by the Copyright Holder(s).
      </p>
      <p>
        “Modified Version” refers to any derivative made by adding to,<br />
        deleting, or substituting – in part or in whole – any of the<br />
        components of the Original Version, by changing formats or by porting<br />
        the Font Software to a new environment.
      </p>
      <p>
        “Author” refers to any designer, engineer, programmer, technical<br />
        writer or other person who contributed to the Font Software.
      </p>
      <p>
        PERMISSION &amp; CONDITIONS<br />
        Permission is hereby granted, free of charge, to any person obtaining<br />
        a copy of the Font Software, to use, study, copy, merge, embed,<br />
        modify, redistribute, and sell modified and unmodified copies of the<br />
        Font Software, subject to the following conditions:
      </p>
      <p>
        1) Neither the Font Software nor any of its individual components, in<br />
        Original or Modified Versions, may be sold by itself.
      </p>
      <p>
        2) Original or Modified Versions of the Font Software may be bundled,<br />
        redistributed and/or sold with any software, provided that each copy<br />
        contains the above copyright notice and this license. These can be<br />
        included either as stand-alone text files, human-readable headers or<br />
        in the appropriate machine-readable metadata fields within text or<br />
        binary files as long as those fields can be easily viewed by the user.
      </p>
      <p>
        3) No Modified Version of the Font Software may use the Reserved Font<br />
        Name(s) unless explicit written permission is granted by the<br />
        corresponding Copyright Holder. This restriction only applies to the<br />
        primary font name as presented to the users.
      </p>
      <p>
        4) The name(s) of the Copyright Holder(s) or the Author(s) of the
        Font<br />
        Software shall not be used to promote, endorse or advertise any<br />
        Modified Version, except to acknowledge the contribution(s) of the<br />
        Copyright Holder(s) and the Author(s) or with their explicit written<br />
        permission.
      </p>
      <p>
        5) The Font Software, modified or unmodified, in part or in whole,<br />
        must be distributed entirely under this license, and must not be<br />
        distributed under any other license. The requirement for fonts to<br />
        remain under this license does not apply to any document created
        using<br />
        the Font Software.
      </p>
      <p>
        TERMINATION<br />
        This license becomes null and void if any of the above conditions are<br />
        not met.
      </p>
      <p>
        DISCLAIMER<br />
        THE FONT SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND,<br />
        EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO ANY WARRANTIES OF<br />
        MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT<br />
        OF COPYRIGHT, PATENT, TRADEMARK, OR OTHER RIGHT. IN NO EVENT SHALL
        THE<br />
        COPYRIGHT HOLDER BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,<br />
        INCLUDING ANY GENERAL, SPECIAL, INDIRECT, INCIDENTAL, OR
        CONSEQUENTIAL<br />
        DAMAGES, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING<br />
        FROM, OUT OF THE USE OR INABILITY TO USE THE FONT SOFTWARE OR FROM<br />
        OTHER DEALINGS IN THE FONT SOFTWARE.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "OpenSourceHsjProAndroid",
  components: {},
  computed: {},
  created() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.hsjpro_opensource {
  .hsjpro_opensource_container {
    padding: 20px;
    font-size: 14px;
    line-height: 1.5;
    word-break: break-all;
  }
}
</style>
